import { MarriageClaimSchema, ObjectSchemaProperty } from "@/models"

const marriageSchemaProperties = ObjectSchemaProperty.getNestedProperties(MarriageClaimSchema)

export function getMarriageClaimProperties() {
	return marriageSchemaProperties
}

export function getObjectSchemaProperty(property: string[]) {
	return marriageSchemaProperties.find((schemaProperty) => schemaProperty.matchesKey(property))
}

export function getRequiredObjectSchemaProperty(property: string[]) {
	const propertyValue = getObjectSchemaProperty(property)
	if (!propertyValue) {
		throw new Error(`Unknown schema property '${property.join(" ")}'`)
	}
	return propertyValue
}
